module.exports = __webpack_public_path__ + "static/media/7.PU Pipes.ddd086be.jpeg";